module.exports = __webpack_public_path__ + "static/media/ic_video_disabled.de3be065.svg";